import { isBlank } from './utils';

export function getDeepValue(data: any, path: string): any {
  if (!data) {
    return '';
  }
  if (data[path] !== undefined) {
    return data[path];
  }
  const fields = path.split('.');
  let currentObject = data;
  for (const field of fields) {
    currentObject = currentObject[field];
    if (isBlank(currentObject)) {
      return '';
    }
  }
  return currentObject;
}

//2013-04-14T14:49:52 - Original
export function getDateValue(data: any, path: string, splitChar?): any {
  if (!data || data[path] == undefined || data[path].length <= 0) {
    return '';
  }
  let splitCharFinal = 'T';
  if (splitChar) {
    splitCharFinal = splitChar;
  }
  //console.log(data)
  let currentObject = data;
  if (path.indexOf("Timestamp") != -1 || path.indexOf("TimeStamp") != -1) {
    let time = (data[path].split(splitCharFinal))[1];//(data[path].split(splitCharFinal))[1];
    let date = (data[path].split(splitCharFinal))[0].split('-');//(data[path].split(splitCharFinal))[0].split('-');
    if (splitCharFinal == 'T')
      currentObject = date[1] + "/" + date[2] + "/" + date[0] + " " + time;
    else
      currentObject = date[1] + "/" + date[0] + "/" + date[2] + " " + time;
  }

  return currentObject;
}
export function getPOLQAValue(data: any, path: string) {
  if (!data || data[path] == undefined || data[path].length <= 0) {
    return '';
  }

  if (data[path] == 0)
    return data[path].toString().replace('0', 'N/A');
  else
    return data[path];
}
export function getDateValueViaValue(value: any, splitChar?): any {
  let splitCharFinal = 'T';
  if (splitChar) {
    splitCharFinal = splitChar;
  }
  //console.log(data)
  let currentObject = value;
  let time = (value.split(splitCharFinal))[1];//(data[path].split(splitCharFinal))[1];
  let date = (value.split(splitCharFinal))[0].split('-');//(data[path].split(splitCharFinal))[0].split('-');
  if (splitCharFinal == 'T')
    currentObject = date[1] + "/" + date[2] + "/" + date[0] + " " + time;
  else
    currentObject = date[1] + "/" + date[0] + "/" + date[2] + " " + time;

  return currentObject;
}
export function getDateValueRowGrp(dateItem) {
  let time = (dateItem.split('T'))[1];//(data[path].split('T'))[1];
  let date = (dateItem.split('T'))[0].split('-');//(data[path].split('T'))[0].split('-');
  let currentObject = date[1] + "/" + date[2] + "/" + date[0] + " " + time;
  return currentObject;
}



//https://stackoverflow.com/questions/52110419/angular-4-settimeout-with-variable-delay-and-wait/52110528
//https://www.learn-it-with-examples.com/development/html-css-javascript/angular/settimeout-angular-example.html
export function iterateAndWait(times) {
  let i = 0;
  (function repeat(times) {
    if (++i > times) return;
    setTimeout(function () {
      //console.log("Iteration: " + i);
      repeat();
    }, 1000);
  })();
}
